import { ListCoursePathFilters } from '@/data/services/coursePathServices';
import {
  VersioningStatusEnum,
  VersioningStatusUIEnum,
} from '@/enums/VersioningStatus';

export const adaptVersioningUIFilters = (
  status: VersioningStatusUIEnum,
): ListCoursePathFilters => {
  if (status === VersioningStatusUIEnum.VERSIONING)
    return {
      status: [VersioningStatusEnum.VERSIONING],
      versionMin: [2],
      versionMax: [Number.MAX_SAFE_INTEGER],
    };
  if (status === VersioningStatusUIEnum.DRAFT)
    return {
      status: [VersioningStatusEnum.VERSIONING],
      versionMin: [0],
      versionMax: [1],
    };
  return { status: [VersioningStatusEnum[status]] };
};
